export var usersListData = [
  {
    ID: 300,
    Username: "dean3004",
    avatar: "avatar-s-10.png",
    Name: "Dean Stanley",
    "Last Activity": "2019/04/30",
    Verified: "No",
    Role: "Staff",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 301,
    Username: "zena0604",
    avatar: "avatar-s-1.png",
    Name: "Zena Buckley",
    "Last Activity": "2020/04/06",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 302,
    Username: "delilah0301",
    avatar: "avatar-s-9.png",
    Name: "Delilah Moon",
    "Last Activity": "2020/01/03",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 303,
    Username: "hillary1807",
    avatar: "avatar-s-10.png",
    Name: "Hillary Rasmussen",
    "Last Activity": "2019/07/18",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 304,
    Username: "herman2003",
    avatar: "avatar-s-16.png",
    Name: "Herman Tate",
    "Last Activity": "2020/03/20",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 305,
    Username: "kuame3008",
    avatar: "avatar-s-12.png",
    Name: "Kuame Ford",
    "Last Activity": "2019/08/30",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 306,
    Username: "fulton2009",
    avatar: "avatar-s-3.png",
    Name: "Fulton Stafford",
    "Last Activity": "2019/09/20",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 307,
    Username: "piper0508",
    avatar: "avatar-s-9.png",
    Name: "Piper Jordan",
    "Last Activity": "2020/08/05",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 308,
    Username: "neil1002",
    avatar: "avatar-s-2.png",
    Name: "Neil Sosa",
    "Last Activity": "2019/02/10",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 309,
    Username: "caldwell2402",
    avatar: "avatar-s-9.png",
    Name: "Caldwell Chapman",
    "Last Activity": "2020/02/24",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 310,
    Username: "wesley0508",
    avatar: "avatar-s-6.png",
    Name: "Wesley Oneil",
    "Last Activity": "2020/08/05",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 311,
    Username: "tallulah2009",
    avatar: "avatar-s-16.png",
    Name: "Tallulah Fleming",
    "Last Activity": "2019/09/20",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 312,
    Username: "iris2505",
    avatar: "avatar-s-7.png",
    Name: "Iris Maddox",
    "Last Activity": "2019/05/25",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 313,
    Username: "caleb1504",
    avatar: "avatar-s-8.png",
    Name: "Caleb Bradley",
    "Last Activity": "2020/04/15",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 314,
    Username: "illiana0410",
    avatar: "avatar-s-6.png",
    Name: "Illiana Grimes",
    "Last Activity": "2019/10/04",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 315,
    Username: "chester0902",
    avatar: "avatar-s-4.png",
    Name: "Chester Estes",
    "Last Activity": "2020/02/09",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 316,
    Username: "gregory2309",
    avatar: "avatar-s-15.png",
    Name: "Gregory Hayden",
    "Last Activity": "2019/09/23",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 317,
    Username: "jescie1802",
    avatar: "avatar-s-17.png",
    Name: "Jescie Parker",
    "Last Activity": "2019/02/18",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 318,
    Username: "sydney3101",
    avatar: "avatar-s-5.png",
    Name: "Sydney Cabrera",
    "Last Activity": "2020/01/31",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 319,
    Username: "gray2702",
    avatar: "avatar-s-7.png",
    Name: "Gray Valenzuela",
    "Last Activity": "2020/02/27",
    Verified: "No",
    Role: "Staff",
    Status: "Close",
    Edit: "",
  },
  {
    ID: 320,
    Username: "hoyt0305",
    avatar: "avatar-s-6.png",
    Name: "Hoyt Ellison",
    "Last Activity": "2020/05/03",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 321,
    Username: "damon0209",
    avatar: "avatar-s-6.png",
    Name: "Damon Berry",
    "Last Activity": "2019/09/02",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 322,
    Username: "kelsie0511",
    avatar: "avatar-s-9.png",
    Name: "Kelsie Dunlap",
    "Last Activity": "2019/11/05",
    Verified: "Yes",
    Role: "User",
    Status: "Close",
    Edit: "",
  },
  {
    ID: 323,
    Username: "abel1606",
    avatar: "avatar-s-6.png",
    Name: "Abel Dunn",
    "Last Activity": "2020/06/16",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 324,
    Username: "nina2208",
    avatar: "avatar-s-6.png",
    Name: "Nina Byers",
    "Last Activity": "2019/08/22",
    Verified: "Yes",
    Role: "User",
    Status: "Close",
    Edit: "",
  },
  {
    ID: 325,
    Username: "erasmus1809",
    avatar: "avatar-s-2.png",
    Name: "Erasmus Walter",
    "Last Activity": "2019/09/18",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 326,
    Username: "yael2612",
    avatar: "avatar-s-6.png",
    Name: "Yael Marshall",
    "Last Activity": "2019/12/26",
    Verified: "Yes",
    Role: "User",
    Status: "Close",
    Edit: "",
  },
  {
    ID: 327,
    Username: "thomas2012",
    avatar: "avatar-s-6.png",
    Name: "Thomas Dudley",
    "Last Activity": "2019/12/20",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 328,
    Username: "althea2810",
    avatar: "avatar-s-6.png",
    Name: "Althea Turner",
    "Last Activity": "2019/10/28",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 329,
    Username: "jena2206",
    avatar: "avatar-s-6.png",
    Name: "Jena Schroeder",
    "Last Activity": "2019/06/22",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 330,
    Username: "hyacinth2201",
    avatar: "avatar-s-6.png",
    Name: "Hyacinth Maxwell",
    "Last Activity": "2019/01/22",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 331,
    Username: "madeson1907",
    avatar: "avatar-s-6.png",
    Name: "Madeson Byers",
    "Last Activity": "2020/07/19",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 332,
    Username: "elmo0707",
    avatar: "avatar-s-7.png",
    Name: "Elmo Tran",
    "Last Activity": "2020/07/07",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 333,
    Username: "shelley0309",
    avatar: "avatar-s-6.png",
    Name: "Shelley Eaton",
    "Last Activity": "2019/09/03",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
  {
    ID: 334,
    Username: "graham0301",
    avatar: "avatar-s-1.png",
    Name: "Graham Flores",
    "Last Activity": "2019/01/03",
    Verified: "No",
    Role: "Staff",
    Status: "Banned",
    Edit: "",
  },
  {
    ID: 335,
    Username: "erasmus2110",
    avatar: "avatar-s-6.png",
    Name: "Erasmus Mclaughlin",
    "Last Activity": "2019/10/21",
    Verified: "Yes",
    Role: "User",
    Status: "Active",
    Edit: "",
  },
];
